import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PanelGuard implements CanActivate {
  constructor(private oidcSecurityService: OidcSecurityService, private router: Router) {}

  canActivate(): Observable<boolean | UrlTree> {
    
    // Check if the user is authenticated
    return this.oidcSecurityService.checkAuth().pipe(
      map((isAuthenticated) => {
        // console.log('******', isAuthenticated);
        if (isAuthenticated.isAuthenticated) {
          return true; // Allow access
        } else {
          // Redirect to the login page if not authenticated

          this.oidcSecurityService.authorize(undefined, {
            customParams: {
              requestCulture: 'fa-IR'
            }
          });
          // return this.router.createUrlTree(['/login']);
        }
      })
    );
  }
}
